import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../navigators/NavigationProp';

import Index, {
  DispatchProps,
  StateProps,
} from '../../../components/cover_image_form/text_preview/Index';

import AppState from '../../../reducers/AppState';

import updateCoverImageForm, {
  Params as CoverImageFormUpdateParams,
} from '../../../actions/cover_image_forms/update';

import {CoverImageFormTextPreviewRouteProp} from '../../../navigators/RouteProps';

interface Props {
  navigation: NavigationProp;
  route: CoverImageFormTextPreviewRouteProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation} = props;
  const {forms} = state;
  const {coverImageForm} = forms;
  return {
    navigation,
    coverImageForm,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    updateCoverImageForm: (params: CoverImageFormUpdateParams) =>
      dispatch(updateCoverImageForm(params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(Index);
